<template>
  <v-navigation-drawer class="primary-navigation" app clipped floating touchless>
    <v-list avatar class="py-0">
      <v-list-tile v-for="(item, i) in items" :key="i" :to="item.to">
        <v-list-tile-avatar>
          <v-icon v-text="item.icon"></v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.text"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <div class="bind-to-bottom text-xs-center py-2">
      <a class="grey--text text--lighten-1" href="http://www.omega-blocktech.com/">omega-blocktech.com</a>
    </div>
  </v-navigation-drawer>
</template>

<script>
  export default {
    data: () => ({
      items: [
        {text: 'Statistics', to: '/', icon: 'timeline'},
        {text: 'Workers', to: '/workers', icon: 'mdi-google-circles-extended'},
        {text: 'Payouts', to: '/payouts', icon: 'mdi-cube-outline'},
        {text: 'Settings', to: '/settings', icon: 'tune'},
      ]
    })
  }
</script>
